export const STALE_TIMES = {
  REALTIME: 10_000,
  FREQUENT: 2 * 60_000,
  STANDARD: 5 * 60_000,
  STATIC: 15 * 60_000,
} as const;
